var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutlined = function SvgStarOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M12.3 3.69a.331.331 0 0 0-.6 0L9.283 8.884a.33.33 0 0 1-.26.188l-5.731.673a.327.327 0 0 0-.186.566l4.237 3.883a.33.33 0 0 1 .1.304l-1.125 5.61a.33.33 0 0 0 .485.35l5.036-2.794a.33.33 0 0 1 .322 0l5.036 2.793a.33.33 0 0 0 .485-.349l-1.125-5.61a.33.33 0 0 1 .1-.304l4.237-3.883a.327.327 0 0 0-.186-.566l-5.73-.673a.33.33 0 0 1-.261-.188zm5.691 7.246-3.188-.374a1.83 1.83 0 0 1-1.446-1.045L12 6.6l-1.357 2.916c-.27.58-.82.971-1.446 1.045l-3.188.374 2.348 2.152c.469.43.683 1.076.557 1.705l-.627 3.126 2.824-1.567a1.83 1.83 0 0 1 1.778 0l2.824 1.567-.627-3.126a1.83 1.83 0 0 1 .557-1.705z",
    clipRule: "evenodd"
  })));
};
export default SvgStarOutlined;